import i from "./index49.js";
function o(r) {
  return i.isObject(r) && r.isAxiosError === !0;
}
export {
  o as default
};
